module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAASlJREFUSEvtlsEOwUAQhv+liUQQvXqAios3kGji6uohXDyLi4dwdZVU0jdwEX0AV4JIJGVForS6OjvBuuh1N/NNd7+ZWQHDnzDMAxvoedIStcPwmqhcFQeuK0JO0iygP9/Yp4I1BtC5Qab5Y9hrNatrXag20F9snVMuNwHgPAUP8udzt9WoBDpQLaAX7DsCGEPCVgYVWEug5zqlKQUlgbPlrg+I651ZRLAQkIN2vTzK2vcS+JBD9qmsk+tilCWTEqiQg8cEXsqUAmbIwYUqZUoASTm4SIVMdyBDDi42IRNpKTc6tf8PpE6Ivf5baYyWRXQ2Rgv/Dk3PPe5d6be2KLLR5h3/HUYHem88xaGkTJ8cwBoyff6JkSHT9x5RaZkMPBO5taHab3xaXAAck6gdzzLCCAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/resume/sort_default_icon.png
// module id = 760
// module chunks = 1